import { getPlatform } from "@shared/utils/get-platform";
import { INotifier } from "./INotifier";
import { WebToastNotifier } from "./WebToastNotifier";

export class NotifierFactory {
  static createNotifier(): INotifier {
    const platform = getPlatform();
    switch (platform) {
      case "WEB":
      case "DESKTOP":
        return new WebToastNotifier();
      case "MOBILE": {
        // Dynamic require to prevent bundling react-native dependencies in web builds
        // eslint-disable-next-line global-require
        const { MobileToastNotifier } = require("./MobileToastNotifier");
        return new MobileToastNotifier();
      }
      default:
        throw new Error(`Unsupported platform: ${platform}`);
    }
  }
}
